import { render, staticRenderFns } from "./FrequentlyAskedQuestionBox.vue?vue&type=template&id=60de407a&"
import script from "./FrequentlyAskedQuestionBox.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAskedQuestionBox.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAskedQuestionBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FrequentlyAskedQuestionBox.vue"
export default component.exports